import { render } from "./HistoryInput3.vue?vue&type=template&id=14938336"
import script from "./HistoryInput3.vue?vue&type=script&lang=js"
export * from "./HistoryInput3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__